import Avatar from '@mui/material/Avatar';

interface Props {
  name: string;
  image: string | undefined;
}

function stringToColor(string: string) {
  let hash = 0;
  let i;

  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }

  return color;
}

function stringAvatar(name: string) {
  const parts = name.split(' ').length;
  return {
    sx: {
      bgcolor: stringToColor(name),
    },
    children: `${name.split(' ')[0][0]}${parts > 1 ? name.split(' ')[1][0] : ''}`,
  };
}

const UserAvatar = ({ name, image }: Props) => {
  return <Avatar alt={name} aria-label="recipe" src={image} {...stringAvatar(name)}></Avatar>;
};

export default UserAvatar;
